// extracted by mini-css-extract-plugin
module.exports = {"SupportCenterView_header":"SupportCenterView_SupportCenterView_header__Eke9i","SupportCenterView_heading":"SupportCenterView_SupportCenterView_heading__q4P7I"};